/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme => ({
  shareemailwithfreestar: {}
});
